import { Footer } from '../components/Footer';

export function Privacy() {
  return (
    <div className="rl-page" style={{ maxWidth: 760 }}>
      <h1 style={{ fontSize: 24, fontWeight: 700, margin: '0 0 8px' }}>Privacy Policy</h1>
      <p style={{ color: 'var(--text-dim)', fontSize: 12, marginBottom: 24 }}>
        Last updated: 2026-06-19
      </p>

      <Article title="What we collect">
        <ul>
          <li>
            <strong>Account.</strong> Email, name, and profile picture from your Google account.
          </li>
          <li>
            <strong>Usage.</strong> Records of separations you start (source URL or upload
            filename, time window, quality, stem) and the resulting outputs.
          </li>
          <li>
            <strong>Saved sections.</strong> Labels, time windows, stem-mix preferences you save
            for replay in Studio or the extension.
          </li>
          <li>
            <strong>Billing.</strong> If you upgrade to Pro, PayPro Global (our authorized reseller /
            merchant of record) handles your payment and card data — we never see card numbers. We
            keep your PayPro order and subscription IDs and invoice history.
          </li>
          <li>
            <strong>Technical.</strong> Standard server logs (IP, user agent, timestamps), kept
            for up to 30 days for abuse prevention.
          </li>
        </ul>
      </Article>

      <Article title="What we don't collect">
        <ul>
          <li>The Riffloop browser extension separates audio <strong>entirely on your device</strong> —
            that audio is never uploaded to our servers.</li>
          <li>We don't keep uploaded audio files after separation completes — they're deleted
            within 24 hours.</li>
          <li>We don't keep separated stems indefinitely — cached stems are pruned after 7 days
            of inactivity.</li>
          <li>We don't sell or rent your data to third parties.</li>
          <li>We don't run ad-tracking pixels or third-party analytics that personally identify
            you.</li>
        </ul>
      </Article>

      <Article title="How we use it">
        <ul>
          <li>To run the service: separate audio, sync your sections, enforce rate limits.</li>
          <li>To bill you (via PayPro Global) if you're on Pro.</li>
          <li>To prevent abuse (rate limits, ToS enforcement).</li>
          <li>To respond to support requests.</li>
        </ul>
      </Article>

      <Article title="Third-party services">
        <ul>
          <li>
            <strong>Google</strong> — sign-in.
          </li>
          <li>
            <strong>PayPro Global</strong> — billing / payment processing.
          </li>
          <li>
            <strong>Cloudways / DigitalOcean</strong> — infrastructure.
          </li>
        </ul>
        Each has its own privacy policy.
      </Article>

      <Article title="Your rights">
        <ul>
          <li>You can delete your account at any time from Settings. We remove your account
            record, saved sections, settings, and separation history within 30 days.</li>
        </ul>
      </Article>

      <Article title="Children">
        Riffloop isn't directed at children under 13. We don't knowingly collect data from minors.
      </Article>

      <Article title="Contact">
        <a href="mailto:riffloopapp@gmail.com">riffloopapp@gmail.com</a>
      </Article>

      <Footer />
    </div>
  );
}

function Article({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section style={{ marginBottom: 28 }}>
      <h2 style={{ fontSize: 16, fontWeight: 600, margin: '0 0 10px' }}>{title}</h2>
      <div style={{ color: 'var(--text-dim)', fontSize: 14, lineHeight: 1.65 }}>{children}</div>
    </section>
  );
}
